import { configureStore } from "@reduxjs/toolkit";
import blogsSlice from "../features/blogs/blogsSlice";
import blogSlice from "../features/blog/blogSlice";
import filterSlice from "../features/filter/filterSlice";
import relatedBlogsSlice from "../features/relatedBlogs/relatedBlogsSlice";

export const store = configureStore({
  reducer: {
    blogs: blogsSlice,
    blog: blogSlice,
    filter: filterSlice,
    relatedBlogs: relatedBlogsSlice,
  },
});
